// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Wx62k","Small":"Button_Small__-MBDp","Medium":"Button_Medium__2AHgo","fullwidth":"Button_fullwidth__SxYE1"};